import React, { useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ExpandMore } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  summaryRoot: {
    minHeight: 'unset',

    '&.Mui-expanded': {
      minHeight: 'unset',
    },
  },
  summaryContent: {
    margin: '0',

    '&.Mui-expanded': {
      margin: '0',
    },
  },
  expandIcon: {
    padding: '5px',
  },
  accordionRoot: {
    '&::before': {
      display: 'none',
    },
  },
}));

const detailsConfig = {
  Star: {
    heading: '20%+ (Star)',
    body: 'Exceptional alignment and impact. Strong recommendation to publish.',
  },
  'Very strong': {
    heading: '15-19% (Very strong)',
    body: 'Performs well in most situations. Safe to implement.',
  },
  Solid: {
    heading: '10-14% (Solid)',
    body: 'Generally effective, but improvements can increase impact.',
  },
  Filler: {
    heading: '0-9% (Filler)',
    body: 'Not bad, but not strong enough. Revise before publishing.',
  },
  Weak: {
    heading: '1 to -10% (Weak)',
    body: 'Likely underperforms. Do not publish without major changes.',
  },
  'High risk': {
    heading: 'Below -10% (High risk)',
    body: 'Poor alignment and potential backlash. Avoid publishing.',
  },
};

const TotalImpactDetails = () => {
  const classes = useStyles();

  const [totalImpactDetailsExpand, setTotalImpactDetailsExpand] = useState({
    Star: false,
    'Very strong': false,
    Solid: false,
    Filler: false,
    Weak: false,
    'High risk': false,
  });

  const totalImpactDetailsExpandHandler = detailType => {
    setTotalImpactDetailsExpand({
      ...totalImpactDetailsExpand,
      [detailType]: !totalImpactDetailsExpand[detailType],
    });
  };

  return (
    <Box>
      {Object.entries(detailsConfig).map(([key, value]) => (
        <Accordion
          key={key}
          classes={{ root: classes.accordionRoot }}
          style={{
            padding: '3px 0',
            backgroundColor: 'transparent',
            boxShadow: 'unset',
            borderBottom: '1px solid lightgrey',
          }}
          expanded={totalImpactDetailsExpand[key]}
          onChange={() => totalImpactDetailsExpandHandler(key)}>
          <AccordionSummary
            classes={{ root: classes.summaryRoot, content: classes.summaryContent, expandIcon: classes.expandIcon }}
            style={{ margin: 0 }}
            expandIcon={<ExpandMore fontSize="small" style={{ color: 'black', padding: 0 }} />}>
            <Typography variant="body2" style={{ color: '#515151', margin: 0, fontWeight: 'bold' }}>
              {value.heading}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>{value.body}</AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default TotalImpactDetails;
